module.exports = __webpack_public_path__ + "img/tip-top.ce2c1f6.png";